'use client';

import { Input, Label } from '@up2stay/up2promo-ui';

import { useDictionary } from '@/core/providers/dictionary-provider';

export interface LocationAddressDetails {
  formatted?: string | null;
  postalCode?: string | null;
  street?: string | null;
  streetNumber?: string | null;
  locality?: string | null;
  administrativeArea?: string | null;
  administrativeAreaLevel2?: string | null;
  country?: string | null;
  countryCode?: string | null;
}

interface LocationDetailsFormProps {
  name: string;
  onNameChange: (name: string) => void;
  nameError?: string | null;
}

export function LocationDetailsForm({
  name,
  onNameChange,
  nameError,
}: LocationDetailsFormProps) {
  const dict = useDictionary();
  const d = dict.locations?.create?.wizard?.detailsStep;

  return (
    <div className="space-y-2">
      <Label htmlFor="location-name">{d?.nameLabel}</Label>
      <Input
        id="location-name"
        type="text"
        placeholder={d?.namePlaceholder}
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        className={nameError ? 'border-destructive' : ''}
        autoComplete="organization"
      />
      {nameError ? (
        <p className="text-sm text-destructive">{nameError}</p>
      ) : null}
    </div>
  );
}
